import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import api from '../../services/api';
import PublicSEO from '../../components/public/PublicSEO';
import { publicPath } from '../../utils/canonicalUrl';
import { buildBreadcrumb } from '../../utils/jsonLd';
import './ContentGuide.css';

/**
 * Pagina pubblica prestazione × città (contenuti SEO pubblicati).
 */
export default function ServizioSeoPage() {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(null);
    api.get(`/seo/servizi/${encodeURIComponent(slug)}`)
      .then((res) => {
        if (!cancelled) setPage(res.data || null);
      })
      .catch(() => {
        if (!cancelled) {
          setPage(null);
          setError('Pagina non trovata o non ancora pubblicata.');
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => { cancelled = true; };
  }, [slug]);

  const title = page?.title || page?.h1 || 'Servizio';
  const description = page?.metaDescription
    || `Informazioni su ${page?.prestazioneNome || 'prestazione'} a ${page?.citta || ''}.`;
  const searchQs = new URLSearchParams();
  if (page?.prestazioneNome) searchQs.set('prestazione', page.prestazioneNome);
  if (page?.citta) searchQs.set('dove', page.citta);

  let jsonLdExtra = [];
  if (page?.jsonLd) {
    try {
      jsonLdExtra = [JSON.parse(page.jsonLd)];
    } catch {
      jsonLdExtra = [];
    }
  }

  return (
    <div className="vc-guide">
      <PublicSEO
        title={title}
        description={description}
        canonicalPath={`/servizi/${slug}`}
        jsonLd={[
          ...jsonLdExtra,
          buildBreadcrumb([
            { name: 'Home', path: '/' },
            { name: 'Servizi', path: '/servizi' },
            { name: page?.h1 || title },
          ]),
        ]}
      />
      <div className="vc-guide__inner">
        {loading && <p>Caricamento…</p>}
        {error && !loading && (
          <>
            <h1>Pagina non disponibile</h1>
            <p className="vc-guide__lead">{error}</p>
            <div className="vc-guide__cta-row">
              <Link to={publicPath('/ricerca')} className="vc-guide__cta">Cerca disponibilità</Link>
            </div>
          </>
        )}
        {page && !loading && (
          <>
            <h1>{page.h1 || page.title}</h1>
            <p className="vc-guide__lead">
              {page.prestazioneNome}
              {page.citta ? ` · ${page.citta}` : ''}
            </p>
            <section>
              <div
                className="vc-guide__body-html"
                // Contenuto editoriale approvato (admin CRM); sanitizzato lato bozza agent.
                dangerouslySetInnerHTML={{ __html: page.bodyHtml || '<p>Contenuto in aggiornamento.</p>' }}
              />
              <div className="vc-guide__cta-row">
                <Link
                  to={`${publicPath('/ricerca')}?${searchQs.toString()}`}
                  className="vc-guide__cta"
                >
                  Cerca disponibilità
                </Link>
                <Link to={publicPath('/come-funziona')} className="vc-guide__cta vc-guide__cta--secondary">
                  Come funziona
                </Link>
              </div>
            </section>
          </>
        )}
      </div>
    </div>
  );
}
